import { rgb } from 'd3-color'

export const toRGBA = (hex, alpha, lighten) => {
  let color = rgb(hex)
  if (lighten) color = color.brighter(lighten)
  color.opacity = alpha
  return color.toString()
}

export const ReplaceDash = ({ children }) => children.replace(/\s*-\s*/g, ' – ')
